import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useWorkerPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "workers:read"),
    canWrite: roleHasPermission(role, "workers:write"),
    canViewPayroll: roleHasPermission(role, "payroll:sensitive"),
    isReadOnly: roleHasPermission(role, "workers:read") && !roleHasPermission(role, "workers:write"),
    role,
  };
}
